<onyx-information-heading [identifierColor]="identifierColor()">
  {{ heading() | translate }}

  @if (showRegistrationNumbers()) {
    <span subheading class="registration-numbers">
      @if (vehicle(); as vehicle) {
        <onyx-link
          color="gray"
          font="f-body-m"
          (click)="openFleetModal(vehicle)"
        >
          {{ vehicle | fleetIdentifier: 'registrationNumber' }}
        </onyx-link>
      } @else {
        -
      }

      <span>/</span>

      @if (trailer(); as trailer) {
        <onyx-link
          color="gray"
          font="f-body-m"
          (click)="openFleetModal(trailer)"
        >
          {{ trailer | fleetIdentifier: 'registrationNumber' }}
        </onyx-link>
      } @else {
        -
      }
    </span>
  }
</onyx-information-heading>

@if (route().length) {
  <app-route
    [points]="route()"
    [vehicleUuid]="vehicleUuid()"
    [fuelType]="fuelType()"
  ></app-route>
} @else {
  <span class="f-muted">
    {{ 'labels.noRoute' | translate }}
  </span>
}
